import React, { forwardRef } from 'react';

import style from './button.module.scss';
import classNames from 'classnames';
import { Icons } from '@/src/types/icon';
import dynamic from 'next/dynamic';
const LocalSpinnerDynamic = dynamic(() => import('./Spinner/LocalSpinner'), {
  ssr: false,
});
const IconDynamic = dynamic(() => import('@/src/v2/components/Icon'), {
  ssr: false,
});
type Props = {
  label?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  type?: ButtonType;
  disabled?: boolean;
  className?: string;
  icon?: Icons;
  icon_height?: number;
  icon_width?: number;
  ref?: React.Ref<HTMLButtonElement>;
};

export type ButtonType =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'primary-v2'
  | 'primary-v2-new'
  | 'dark'
  | 'close-modal'
  | 'secondary-v2';

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      className = '',
      loading = false,
      label,
      type = 'primary',
      onClick,
      disabled = false,
      icon,
      icon_height = 12,
      icon_width = 12,
    },
    ref
  ) => {
    return (
      <button
        className={classNames(
          style['button'],
          { [`${className}`]: !!className },
          { [`${style[className]}`]: !!className },
          { [`${style[`button--${type}`]}`]: true }
        )}
        disabled={loading || disabled ? true : false}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          if (!disabled) {
            onClick(e);
          }
        }}
        ref={ref}
        title={label}
      >
        {loading && (
          <LocalSpinnerDynamic
            color={
              type === 'primary'
                ? 'var(--color-black)'
                : 'var(--color-text-primary)'
            }
            isLoading={loading}
          />
        )}
        <div className={style['button--content']}>
          {icon && (
            <IconDynamic
              icon={icon}
              width={icon_width ?? 12}
              height={icon_height ?? 12}
            />
          )}
          {label && !loading ? (
            <span>{label}</span>
          ) : (
            <span
              style={{
                marginLeft: '1px',
                marginRight: '1px',
                visibility: 'hidden',
              }}
            >
              {label}
            </span>
          )}
        </div>
      </button>
    );
  }
);
Button.displayName = 'Button';
export default Button;
